import BlockBlot from 'quill/blots/block';
class LoadingImageBlot extends BlockBlot {
  static create(src): HTMLElement {
    const node = super.create(src);
    if (src === true) {
      return node;
    }

    const image = document.createElement('img');
    image.setAttribute('src', src);
    node.appendChild(image);
    return node;
  }
  static value(domNode): { src: string; custom: string } {
    const { src, custom } = domNode.dataset;
    return { src, custom };
  }
  deleteAt(index, length): void {
    super.deleteAt(index, length);
    this.cache = {};
  }
}

LoadingImageBlot.blotName = 'imageBlot';
LoadingImageBlot.tagName = 'span';
LoadingImageBlot.className = 'image-uploading';
export default LoadingImageBlot;
